import type { DifferenceOptions } from "./DifferenceOptions";
import dateTime from "./dateTime";

export default function differenceInHours(
  dateLeft: Date,
  dateRight: Date,
  diffOptions?: DifferenceOptions,
) {
  return dateTime(dateLeft).difference(dateRight, "hours", diffOptions);
}
